// extracted by mini-css-extract-plugin
export default {"quick-operation-container":"quick-operation-container___ZB8c3"};